import { render, staticRenderFns } from "./FeedbackRate.vue?vue&type=template&id=523cc638&"
import script from "./FeedbackRate.vue?vue&type=script&lang=js&"
export * from "./FeedbackRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports